// extracted by mini-css-extract-plugin
module.exports = {"root":"HousePromo_root__2jjMC","swanInjected":"HousePromo_swanInjected__QxjKZ"};